export const GET_TRANSACTION_INIT = "GET_TRANSACTION_INIT";
export const GET_TRANSACTION_SUCCESS = "GET_TRANSACTION_SUCCESS";
export const GET_TRANSACTION_ERROR = "GET_TRANSACTION_ERROR";
//plopImport